// ルーティングに関する型やヘルパー関数を定義する。

import queryString from 'query-string';

export type Query = Record<string, string | undefined>;

export type paramInfo = {
    paramName: string;
    paramValue: string | undefined;
};

export const basepath = '/app/login';

/** ログイン画面 */
export const pathToLogin = (query?: Query) => createUrl(basepath, query);

/** ネクストアカウントログイン画面 */
export const pathToNextAccountLogin = (query?: Query) => createUrl([basepath, 'smilenext'].join('/'), query);

/** シングルサインオンログイン画面 */
export const pathToSSOLogin = (query?: Query) => createUrl([basepath, 'single-sign-on'].join('/'), query);

/** シングルサインオンのコールバック画面 */
export const pathToSSOCallback = (query?: Query) =>
    createUrl([basepath, 'single-sign-on', 'authenticated'].join('/'), query);

/** ホーム画面 */
export const pathToHome = () => '/app/portal/home';

/** ベースURLと渡されたパラメータオブジェクトより、URLを生成する */
function createUrl(baseUrl: string, query?: Query) {
    if (!query) {
        return baseUrl;
    }

    const queryUrl = queryString.stringify(query, {
        encode: true,
        skipNull: true,
    });

    return queryUrl ? `${baseUrl}?${queryUrl}` : baseUrl;
}

const values = {
    pathToLogin,
    pathToNextAccountLogin,
    pathToSSOLogin,
    pathToSSOCallback,
    pathToHome,
};

export default values;
